
import { useContext } from 'react';
import { FutureReleasesContext } from './FutureReleasesContext';

export const useFutureReleases = () => {
  const context = useContext(FutureReleasesContext);
  if (context === undefined) {
    throw new Error('useFutureReleases must be used within a FutureReleasesProvider');
  }
  return context;
};
